import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { smallXsmallGroup } from '../../avatars/group-avatar/group-icons';
import { Icon } from '../icon/icon';
import { EllipsisText } from '../../composites/ellipsis-text/ellipsis-text';
export var StaticLabelKey = 'static-label';
export var StaticLabelTextKey = 'static-label-text';
export var StaticLabelType;
(function (StaticLabelType) {
    StaticLabelType[StaticLabelType["INFO"] = 1] = "INFO";
    StaticLabelType[StaticLabelType["NEUTRAL"] = 2] = "NEUTRAL";
    StaticLabelType[StaticLabelType["NEUTRALICON"] = 3] = "NEUTRALICON";
    StaticLabelType[StaticLabelType["BLANK"] = 4] = "BLANK";
})(StaticLabelType || (StaticLabelType = {}));
export var StaticLabelSize;
(function (StaticLabelSize) {
    StaticLabelSize[StaticLabelSize["SMALL"] = 1] = "SMALL";
    StaticLabelSize[StaticLabelSize["MEDIUM"] = 2] = "MEDIUM";
})(StaticLabelSize || (StaticLabelSize = {}));
var StaticLabel = /** @class */ (function (_super) {
    __extends(StaticLabel, _super);
    function StaticLabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        return _this;
    }
    StaticLabel.prototype.render = function () {
        var props = this.props;
        var size = StaticLabelSize[props.size].toLowerCase();
        var type = StaticLabelType[props.type].toLowerCase();
        var icon = props.icon
            ? React.createElement(Icon, { icon: props.icon })
            : props.type === StaticLabelType.NEUTRALICON
                ? React.createElement(Icon, { icon: smallXsmallGroup })
                : null;
        var classNames = namespacedClassnames(StaticLabelKey, type, props.className);
        var textClassNames = namespacedClassnames(StaticLabelTextKey, size);
        return (React.createElement("div", { className: classNames },
            icon,
            React.createElement(EllipsisText, { className: 'static-label-text-wrapper', noTooltip: props.noTooltip },
                React.createElement("div", { className: textClassNames }, props.name))));
    };
    return StaticLabel;
}(React.PureComponent));
export { StaticLabel };
//# sourceMappingURL=index.js.map